import React from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { Trad } from "src/components";
import { _ContextMenu } from "../../components";
import { IProvvigioniProduct } from "./CommissionsForm";

interface ICommissionsDetailsProps {
    Data: IProvvigioniProduct[];
    OnChange: (e: string, val: unknown) => void;
    OnCopyValues: (index: number) => any;
}

export const _CommissionsDetails: React.FC<ICommissionsDetailsProps> = ({ Data, OnCopyValues, OnChange }) => {
    const onChangeCommission = (e: React.FormEvent<any>, index: number): void => {
        let commissionData = Data[index].ProvvigioniJSON && Data[index].ProvvigioniJSON != "{}" ? JSON.parse(Data[index].ProvvigioniJSON) : [];

        commissionData = commissionData.map((item: any) => {
            if (Object.keys(item.Parametri)[0] == e.currentTarget.id) {
                item.Parametri[e.currentTarget.id] = e.currentTarget.value;
            }
            return item;
        });

        OnChange(`${Data[index].Index}.ProvvigioniJSON`, JSON.stringify(commissionData));
    };

    return (
        <Grid container spacing={4}>
            <Grid item xs={12} md={11}>
                <Typography variant="h6" color="primary">
                    {Trad.Trad(Data[0].TipoRamo)} - {Trad.Trad(Data[0].TipoProdotto)}
                </Typography>
            </Grid>

            {Data.map((product, index) => {
                const commissionData = product.ProvvigioniJSON && product.ProvvigioniJSON != "{}" ? JSON.parse(product.ProvvigioniJSON) : [];
                return (
                    <React.Fragment key={product.Index}>
                        <Grid item xs={12} md={1}>
                            <_ContextMenu OnCopyValues={OnCopyValues(product.Index)} />
                        </Grid>
                        {commissionData.map((commission: any, i: number) => {
                            const commissionType = Object.keys(commission.Parametri)[0];

                            return (
                                <Grid item container spacing={4} key={i}>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            fullWidth
                                            id={commissionType}
                                            label={Trad.Trad(commissionType)}
                                            value={commission.Parametri[commissionType]}
                                            onChange={(e: React.FormEvent<any>) => onChangeCommission(e, index)}
                                            inputProps={{ type: "number", min: "1", max: "99" }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField fullWidth disabled name="Funzione" label={Trad.Trad("Commission Calculation Method")} value={commission.Funzione} />
                                    </Grid>
                                </Grid>
                            );
                        })}
                    </React.Fragment>
                );
            })}
        </Grid>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/Commissions/CommissionsDetails.tsx